<template>
  <div>
    <CrudList
      title="Sales"
      storeName="Sales"
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      :canExport="true"
      :filters="filters_obj"
      sortable
      :canSearch="false"
      @set_total_sales="set_total_sales"
    >
      <template v-slot:date_sales="{ options }">
        <v-row class="justify-end d-flex ">
          <v-col cols="12" class="col-3 vertical-middle">
            <v-btn
              depressed
              color="primary"
              class="mt-5"
              v-on:click="exportBtn"
            >
              <v-icon left>fas fa-download</v-icon>
              Export as
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="list_companies"
              :items="companies"
              item-value="id"
              item-text="name"
              label="Company"
              prepend-icon="fas fa-building"
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchCompanyTerm"
                      placeholder="Search"
                      @input="searchCompanies"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>

                <v-list-item ripple @mousedown.prevent @click="toggleCompany">
                  <v-list-item-action>
                    <v-icon
                      :color="
                        list_companies.length > 0 ? 'indigo darken-4' : ''
                      "
                    >
                      {{ icon_company }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <div v-if="index === 0">
                  <span>{{ item.name }}</span>
                </div>
                <span v-if="index === 1" class="grey--text text-caption ml-1">
                  (+{{ list_companies.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="6">
            <div>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                :nudge-right="20"
                transition="scale-transition"
                offset-y
                min-width="auto"
                class="float-left"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-icon="fas fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dates" range no-title scrollable>
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>

          <v-col cols="6">
            <v-select
              v-model="list_stores"
              :items="stores"
              item-value="id"
              item-text="name"
              label="Store"
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchTerm"
                      placeholder="Search"
                      @input="searchStores"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>

                <v-list-item ripple @mousedown.prevent @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="list_stores.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <div v-if="index === 0">
                  <span>{{ item.name }}</span>
                </div>
                <span v-if="index === 1" class="grey--text text-caption ml-1">
                  (+{{ list_stores.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="list_users"
              :items="users"
              item-value="id"
              item-text="email"
              label="Users"
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchUserTerm"
                      placeholder="Search"
                      @input="searchUsers"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>

                <v-list-item ripple @mousedown.prevent @click="toggleUser">
                  <v-list-item-action>
                    <v-icon
                      :color="list_users.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon_user }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <div v-if="index === 0">
                  <span>{{ item.email }}</span>
                </div>
                <span v-if="index === 1" class="grey--text text-caption ml-1">
                  (+{{ list_users.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-btn @click="applySearch">
              Search
              <v-icon class="ml-2">fas fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:card_sales>
        <v-card class="mb-6">
          <v-row>
            <v-col sm="5">
              <v-row no-gutters>
                <v-col cols="8" sm="6">
                  <div class="ml-2">
                    <div class="my-0 text-subtitle-1">
                      TOTAL SALES
                    </div>
                    <v-card-title
                      class="subheading font-weight-bold"
                      style="padding: 0;"
                    >
                      ${{ total_sales.toFixed(2) }}
                    </v-card-title>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template v-slot:created_at="{ item }">
        {{ item.order_id && item.order_id.date_timezone?formatDate(item.order_id.date_timezone,'MM-DD-YYYY HH:mm:ss'):item.created_at }}
      </template>
      <template v-slot:client_id="{ item }">
        <v-row>
          <v-col
            cols="1"
            class="mr-6"
            v-if="item.client_id && item.client_id.profile_picture"
          >
            <v-list-item-avatar>
              <img :src="item.client_id.profile_picture" alt="" />
            </v-list-item-avatar>
          </v-col>
          <v-col>
            <h4>
              {{
                item.client_id && item.client_id.fullname
                  ? item.client_id.fullname
                  : ""
              }}
            </h4>
            <div>
              <span>{{
                item.client_id && item.client_id.email
                  ? item.client_id.email
                  : ""
              }}</span>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-slot:guard_id="{ item }">
        <v-row v-if="item.order_id && item.order_id.guard">
          <!--        <v-col cols="1" class="mr-6">


    <template v-slot:client_id="{ item }">
      <v-row >
        <v-col cols="1" class="mr-6" v-if="item.client_id.profile_picture">
          <v-list-item-avatar >
             <img :src="item.client_id.profile_picture" alt=""/>
           </v-list-item-avatar>
        </v-col>
        <v-col >
          
          <h4>{{ item.client_id.fullname }}</h4>
          <div>
            <span>{{ item.client_id.email }}</span>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:guard_id="{ item }">
      <v-row v-if="item.order_id && item.order_id.guard">
       <v-col cols="1" class="mr-6">
          <v-list-item-avatar >
             <img :src="item.order_id.guard.picture" alt=""/>
           </v-list-item-avatar>
        </v-col>-->
          <v-col>
            <h4>{{ item.order_id.guard.fullname }}</h4>
            <div>
              <span>{{ item.order_id.guard.email }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <h4>Not found Guard</h4>
          </v-col>
        </v-row>
      </template>
      <template v-slot:payment_method="{ item }">
        <v-row align="center" justify="center" v-if="item.order_id">
          <v-col>
            <v-iframe-icons-payments class="iframe-icon-payment">
              <img
                v-if="item.order_id.payment_method_brand == 'amex'" 
                class="icon-payment"
                :src="
                  require('@/assets/img/icons_payment/ic_american_express.png')
                "
                alt="American express"
              />

              <img v-if="item.order_id.payment_method_brand == 'discovery'"
                class="icon-payment2"
                :src="require('@/assets/img/icons_payment/ic_discover.png')"
                alt="Discover"
              />

              <img v-if="item.order_id.payment_method_brand == 'mastercard'"
                class="icon-payment2"
                :src="require('@/assets/img/icons_payment/ic_master_card.png')"
                alt="Master Card"
              />

              <img v-if="item.order_id.payment_method_brand == 'visa'"
                class="icon-payment"
                :src="require('@/assets/img/icons_payment/ic_visa.png')"
                alt="Visa"
              />

              <img v-if="item.order_id.payment_method_brand !== 'amex' &&
                        item.order_id.payment_method_brand !== 'discovery' &&
                        item.order_id.payment_method_brand !== 'mastercard' &&
                        item.order_id.payment_method_brand !== 'visa'
                      "
                class="icon-payment2"
                :src="require('@/assets/img/icons_payment/ic_stripe.png')"
                alt="Stripe"
              />

            </v-iframe-icons-payments>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <h4>Not found Guard</h4>
          </v-col>
        </v-row>
      </template>
      <template v-slot:order_id="{ item }">
        <v-row>
          <v-col cols="8">
            <p>{{ item.order_id.items.length }}</p>
          </v-col>
        </v-row>
      </template>

      <template v-slot:tax="{ item }">
        <v-row>
          <v-col>
            <p>{{ (item.order_id.taxes || 0).toFixed(2) }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:amount="{ item }">
        <v-row>
          <v-col class="mr-4">
            {{ (item.amount / 100).toFixed(2) }}
          </v-col>
        </v-row>
      </template>

      <template v-slot:pay_status="{ item }">
        <v-row align="center" justify="center">
          <v-chip
            v-if="item.pay_status"
            :color="`teal lighten-4`"
            class="ml-0 mr-2 black--text"
            label
            small
          >
            {{ item.pay_status }}
          </v-chip>
        </v-row>
      </template>
      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.image">
              <img :src="item.image" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<style>
.content-export {
  margin-right: 11rem;
}
button.mt-3.btn-add.v-btn.v-btn--has-bg.theme--light.elevation-0.v-size--default.primary {
  background-color: transparent !important;
  color: transparent;
}
.v-toolbar__content
  button.ml-5.mr-5.v-btn.v-btn--text.theme--light.elevation-0.v-size--default {
  float: right;
  margin-top: 5.75rem;
  color: #fff !important;
  background-color: var(--v-primary-base) !important;
  border-color: var(--v-primary-base) !important;
}
</style>
<script>
import CrudList from "@/components/Crud/CrudList";
import { mapActions, mapState } from "vuex";
import { config } from "@/config/constants.js";
import moment from "moment";

export default {
  components: { CrudList },
  async created() {
    let stores = await this.getStores({ show_all: "enable" });
    this.list_stores = stores.map(data => data.id);

    let users = await this.getUsers({ show_all: "enable", stores_id: this.list_stores });
    this.list_users = users.map(data => data.id);

    let companies = await this.getCompanies({ show_all: "enable" });
    this.list_companies = companies.map(data => data.id);

    const first_filter = {
      stores: this.list_stores,
      users: this.list_users,
      companies: this.list_companies,
      filter_enable: ["store", "user", "dates", "companies"]
    };
    this.filters_obj = { ...this.filters_obj, ...first_filter };
    this.init_filter = false;
    /*setTimeout(()=>{
      this.loaded_filter = true
    },200)*/
  },
  watch: {
    /*list_stores(val) {
        if(!this.init_filter){
          this.filters_obj = { ...this.filters_obj, stores: val,filter_enable:['store','user','dates','companies']};
        }
      },
      list_users(val) {
        if(!this.init_filter) {
          this.filters_obj = {...this.filters_obj, users: val, filter_enable: ['store', 'user', 'dates', 'companies']};
        }
      },
      list_companies(val) {
        if(!this.init_filter) {
          this.filters_obj = {
            ...this.filters_obj,
            companies: val,
            filter_enable: ['store', 'user', 'dates', 'companies']
          };
        }
      },*/
    dates(val) {
      if (val.length === 2) {
        this.dateRangeText = val.join(" ~ ");
        /*if (val[0] >= val[1]) {
            this.filters_obj = {
              ...this.filters_obj,
              start_date: val[1],
              end_date: val[0],
              filter_enable:['store','user','dates','companies']
            };
          }
          if (val[1] >= val[0]) {
            this.filters_obj = {
              ...this.filters_obj,
              start_date: val[0],
              end_date: val[1],
              filter_enable:['store','user','dates','companies']
            };
          }*/
        this.$refs.menu.save(val);
        //this.menu = false
        //this.filters_obj = { ...this.filters_obj, stores: val };
      }
    },
    async list_companies(val){
      if(val && this.loaded_filter){
        let stores = await this.getStores({ show_all: "enable",company_id:val });
        this.list_stores = stores.map(data => data.id);

      }
      if(val && !this.init_filter && !this.loaded_filter){
        this.loaded_filter = true;
      }
    },
    async list_stores(val){
      if(val && this.loaded_filter){
        let users = await this.getUsers({ show_all: "enable",stores_id:val });
        this.list_users = users.map(data => data.id);
      }
      if(val && !this.init_filter && !this.loaded_filter){
        this.loaded_filter = true;
      }
    },

  },
  computed: {
    ...mapState({
      stores: state => state.Stores.list,
      users: state => state.Users.list,
      companies: state => state.Companies.list
    }),
    likesAllUser() {
      return this.list_users.length === this.users.length;
    },
    likesSomeUser() {
      return this.list_users.length > 0 && !this.likesAllUser;
    },
    likesAllFruit() {
      return this.list_stores.length === this.stores.length;
    },
    likesSomeFruit() {
      return this.list_stores.length > 0 && !this.likesAllFruit;
    },
    likesAllCompany() {
      return this.list_companies.length === this.companies.length;
    },
    likesSomeCompany() {
      return this.list_companies.length > 0 && !this.likesAllCompany;
    },
    /*dateRangeText() {

        if (this.dates.length === 2){


          return this.dates.join(" ~ ");
        }
        //if(this.dates.length===1) return this.dates[0]
        return "";
      },*/
    icon() {
      if (this.likesAllFruit) return "fas fa-check-square";
      if (this.likesSomeFruit) return "far fa-square";

      return "far fa-square";
    },
    icon_user() {
      if (this.likesAllUser) return "fas fa-check-square";
      if (this.likesSomeUser) return "far fa-square";
      return "far fa-square";
    },
    icon_company() {
      if (this.likesAllCompany) return "fas fa-check-square";
      if (this.likesSomeCompany) return "far fa-square";
      return "far fa-square";
    }
  },
  data() {
    return {
      token: this.$store.state["Authenticate"].token,
      filters_obj: {},
      visa:
        "https://logodownload.org/wp-content/uploads/2016/10/visa-logo-1.png",
      date: [],
      list_stores: [],
      users_copy: [],
      dates: [],
      menu: false,
      dateRangeText: "",
      searchTerm: "",
      searchUserTerm: "",
      searchCompanyTerm: "",
      list_users: [],
      list_companies: [],
      searchUser: "",
      total_sales: 0,
      init_filter: true,
      loaded_filter: false
    };
  },
  methods: {
    ...mapActions({
      getStores: (dispatch, args) => dispatch("Stores/getListAll", args),
      getUsers: (dispatch, args) => dispatch("Users/getListAll", args),
      getCompanies: (dispatch, args) => dispatch("Companies/getListAll", args)
    }),
    saveDate() {
      if (this.dates.length === 2) {
        //this.menu = false
      }
    },
    async changeData(dates) {
      const self = this;
      await self.$store.dispatch("Insights/getListAll", { dates: dates });
    },
    exportBtn() {
      const self = this;

      const queryString = Object.keys(this.filters_obj)
        .map(key => key + "=" + this.filters_obj[key])
        .join("&");
      window.location.href =
        config.api_url +
        'Sales' +
        "?format=csv&" +
        queryString +
        "&authorization=" +
        this.token;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.list_stores = [];
        } else {
          this.list_stores = this.stores.map(data => data.id).slice();
        }
      });
    },
    async searchStores(e) {
      const self = this;
      this.list_stores = [];
      await self.$store.dispatch("Stores/getListAll", {
        search: self.searchTerm,
        show_all: "enable"
      });
      //self.filters_obj = { ...self.filters_obj, stores: self.list_stores };
    },
    toggleUser() {
      this.$nextTick(() => {
        if (this.likesAllUser) {
          this.list_users = [];
        } else {
          this.list_users = this.users.map(data => data.id).slice();
        }
      });
    },
    async searchUsers(e) {
      const self = this;
      this.list_users = [];
      await self.$store.dispatch("Users/getListAll", {
        search: self.searchUserTerm,
        show_all: "enable"
      });
      //self.filters_obj = { ...self.filters_obj, users: self.list_users,filter_enable:['store','user','dates'] };
    },
    toggleCompany() {
      this.$nextTick(() => {
        if (this.likesAllCompany) {
          this.list_companies = [];
        } else {
          this.list_companies = this.companies.map(data => data.id).slice();
        }
      });
    },
    async searchCompanies(e) {
      const self = this;
      this.list_companies = [];
      await self.$store.dispatch("Companies/getListAll", {
        search: self.searchCompanyTerm,
        show_all: "enable"
      });
      //self.filters_obj = { ...self.filters_obj, companies: self.list_companies,filter_enable:['store','user','dates','companies'] };
    },
    set_total_sales(val) {
      this.total_sales = val;
    },
    applySearch() {
      const self = this;
      let filter_dates = {};
      if (self.dates[0] >= self.dates[1]) {
        filter_dates = {
          start_date: self.dates[1],
          end_date: self.dates[0]
        };
      }
      if (self.dates[1] >= self.dates[0]) {
        filter_dates = {
          start_date: self.dates[0],
          end_date: self.dates[1]
        };
      }
      self.filters_obj = {
        ...self.filters_obj,
        ...filter_dates,
        companies: self.list_companies,
        users: self.list_users,
        stores: self.list_stores,
        filter_enable: ["store", "user", "dates", "companies"]
      };
    },
    formatDate: (date, format = "H:mm:ss MM/DD/YYYY") =>
        moment(date).utc().format(format)
  }
};
</script>
